module.exports = __webpack_public_path__ + "static/media/wind-solid.d7df161e.svg";